import * as types from '../_actions/actionTypes';
import _ from 'lodash';

const _departmentList = [];

export function DepartmentReducer(
  state = { departmentList: _departmentList },
  action
) {
  switch (action.type) {
    case types.FETCH_DEPARTMENTSLIST:
      return { departmentList: action.payload };
    case types.FETCH_DEPARTMENTSLIST_FAILURE:
      return { departmentList: _departmentList };
    default:
      return state;
  }
}
